import { useEffect } from 'react';
import { NAVIGATION_KEYS } from '../constants/navigation-keys';
export const useIsUsingKeyboardToNavigate = ({ onChange, }) => {
    useEffect(() => {
        const handleKey = (event) => {
            if (NAVIGATION_KEYS.includes(event.key)) {
                onChange(true);
            }
        };
        const handleMouse = () => {
            onChange(false);
        };
        document.addEventListener('keydown', handleKey);
        document.addEventListener('mousemove', handleMouse);
        return () => {
            document.removeEventListener('keydown', handleKey);
            document.removeEventListener('mousemove', handleMouse);
        };
    }, [onChange]);
};
